import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/dashboardUrl';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.DASHBOARD_URL);

export const useGetDashboardUrl = (sessionToken) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(),
        queryFn: async () => {
            const config = await Client.fetchOne(sessionToken);

            if (!config) return {};
            return config?.[0]?.value;
        },
        onSuccess: (data) => {
            // console.log('Success fetch code systems', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
